<template>
  <div class="shop-layout">
    <Header class="header" />
    <div class="main">
      <router-view class="page mb-10" />
    </div>
    <MobileFooter v-if="mobile || tablet" class="footer" />
    <Footer v-else class="footer" />
  </div>
</template>

<script>
import Header from "@/components/shop/Header.vue";
import Footer from "@/components/shared/Footer.vue";
import MobileFooter from "@/components/shop/MobileFooter.vue";
import getDefaultLocation from "@/util/getDefaultLocation";

export default {
  components: {
    Header,
    Footer,
    MobileFooter
  },
  data() {
    return {
      confirmationToken: "",
      axiosOptions: {},
      user: {}
    };
  },
  async mounted() {
    const res = await this.$api.get("users/profile", this.axiosOptions);

    this.$store.commit("setData", {
      is_confirmed: res.result.user.is_confirmed,
      is_completed_required_info: res.result.user.is_completed_required_info
    });

    const obj = {
      user: res.result.user,
      defaultLocation: getDefaultLocation(res.result.user.shop.locations)
    };

    this.$store.commit("setProfile", obj);

    if (!res.result.user.is_completed_required_info) {
      const userType = this.$store.state.auth.user_type;
      const accessToken = this.$store.state.auth.access_token;
      this.$router.push({ path: `/users/confirm?type=${userType}`, params: { access_token: accessToken } });
    } else if (!res.result.user.is_confirmed) {
      this.$router.push({
        path: "/users/wait_confirmed",
        query: {
          type: res.result.user.user_type,
          email: res.result.user.email
        }
      });
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs;
    },
    tablet() {
      return this.$vuetify.breakpoint.sm;
    }
  }
};
</script>

<style lang="scss" scoped>
.shop-layout {
  display: grid;
  grid-template-rows: auto 1fr auto;
  color: #0c1624;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.header {
  position: sticky;
  top: 0;
  z-index: 1;
}

.main {
  position: relative;
  min-width: 0;
  z-index: 0;
}

.page {
  padding-bottom: 60px;
  min-height: 100%;

  @media screen and (max-width: 960px) {
    padding-top: 20px;
    padding-bottom: 20px;
  }
}
</style>
